/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

/**
 * Application role, ordered from read-only viewer through superuser.
 */
export type Role = typeof Role[keyof typeof Role];


export const Role = {
  viewer: 'viewer',
  member: 'member',
  superuser: 'superuser',
} as const;
